import "../../css/GameRoom.css"

const EmptyGameBox = ({gameType, handleEmptyClick}) =>{

    const handleClick = (gameType) =>{
        handleEmptyClick(gameType);
    }

    const getGameBoxBg = () =>{
        if(gameType === "jumper")
            return "/assets/games/gamebox/gamebox_jumper_empty.png"
        else if(gameType === "runner")
            return "/assets/games/gamebox/gamebox_runner_empty.png"
        else if(gameType === "invader")
            return "/assets/games/gamebox/gamebox_invader_empty.png"
        else if(gameType === "platformer")
            return "/assets/games/gamebox/gamebox_platformer_empty.png"
    }

    return(
        <div className="game-box" onClick={()=>handleClick(gameType)}>
            <img className="game-card-bg" src={getGameBoxBg()} />
        </div>
    )
}

export default EmptyGameBox;